import React from "react";
import { formatIncomingDate } from "./incomingPatientDates";
import { getIncomingBookingPolicy, incomingBookingDay } from "./incomingBookingAvailability";

const getHealthInsurance = (value) => {
  const insurance = String(value || "").trim();
  return ["กรุณาเลือก", "please-select"].includes(insurance) ? "" : insurance;
};

export default function IncomingSleepTestSchedule({ day, customer, nodeId, nodeName, bookings, incomingPatients = [], onEditIncoming, loading, error }) {
  const scheduled = bookings.filter((booking) => {
    const props = booking.extendedProps || {};
    const policy = getIncomingBookingPolicy(props.customer);
    const hasPatient = [props.firstname, props.lastname].some((name) => String(name || "").trim());
    return hasPatient && props.status === "Sleep Test Scheduled" && incomingBookingDay(booking.start) === day &&
      policy && policy.customer === customer;
  }).map((booking) => {
    const props = booking.extendedProps;
    const scopedIncoming = incomingPatients.filter((patient) => {
      const policy = getIncomingBookingPolicy(patient.refCustomer);
      return patient.nodeRef === nodeName && policy && policy.customer === customer &&
        !(props.hn && patient.hn && props.hn !== patient.hn);
    });
    const linked = scopedIncoming.filter((patient) => patient.incomingBooking &&
      patient.incomingBooking.path === `nodes/${nodeId}/bookings/${booking.id}`);
    const incomingMatches = props.incomingPatientId ? scopedIncoming.filter((patient) => patient.id === props.incomingPatientId) :
      linked.length ? linked : scopedIncoming.filter((patient) => props.hn && patient.hn === props.hn);
    const incomingPatient = incomingMatches.length === 1 ? incomingMatches[0] : null;
    const hospitalHn = String(props.hospitalNumber || "").trim() || String(props.refHn || "").trim() ||
      (incomingPatient ? String(incomingPatient.refHn || "").trim() : "");
    const healthInsurance = getHealthInsurance(props.healthInsurance) ||
      getHealthInsurance(incomingPatient && incomingPatient.healthInsurance);
    const isCash = ["ชำระเงินเอง", "เงินสด", "cash", "self-pay", "self pay"].includes(healthInsurance.toLowerCase());
    const phone = String(props.phone || "").trim() || String(incomingPatient && incomingPatient.mobile || "").trim();
    return { booking, incomingPatient, hospitalHn, healthInsurance, isCash, phone };
  }).sort((a, b) => Number(b.isCash) - Number(a.isCash) ||
    String(a.booking.extendedProps.order || "").localeCompare(String(b.booking.extendedProps.order || ""), "th", { numeric: true }));

  return (
    <section className="incoming-schedule-panel" aria-label="Sleep Test Scheduled">
      <div className="incoming-schedule-heading">
        <div><h5>Sleep Test Scheduled</h5><p>{customer} · {nodeName}</p></div>
        <span className="incoming-schedule-date">{formatIncomingDate(day)}</span>
      </div>
      <div aria-live="polite">
        {loading ? <p className="incoming-schedule-message" role="status">กำลังโหลดนัดตรวจ…</p> : error ?
          <p className="incoming-schedule-message text-danger" role="alert">โหลดนัดตรวจไม่สำเร็จ กรุณากดอัปเดตที่ปฏิทิน</p> :
          <>
            <p className="incoming-schedule-count">นัดตรวจ {scheduled.length} คน</p>
            {scheduled.length ? <div className="incoming-schedule-scroll" role="region" aria-label="Scheduled patients" tabIndex={0}>
              <table className="table incoming-schedule-table mb-0">
                <colgroup><col style={{ width: "34%" }} /><col style={{ width: "27%" }} /><col style={{ width: "23%" }} /><col style={{ width: "16%" }} /></colgroup>
                <thead><tr><th scope="col">ผู้ป่วย / HN</th><th scope="col" title="Order / สิทธิการเบิก">Order / สิทธิการเบิก</th><th scope="col">เบอร์ติดต่อ</th><th scope="col" title="แก้ไข Incoming">Incoming</th></tr></thead>
                <tbody>{scheduled.map(({ booking, incomingPatient, hospitalHn, healthInsurance, isCash, phone }) => {
                  const props = booking.extendedProps;
                  const name = [props.firstname, props.lastname].map((value) => String(value || "").trim()).filter(Boolean).join(" ");
                  return <tr key={booking.id}>
                    <td><div className="incoming-schedule-cell"><strong title={name}>{name}</strong><span className="incoming-secondary" title={props.hn || ""}>Company HN: {props.hn || "—"}</span><span className="incoming-secondary" title={hospitalHn}>Hospital HN: {hospitalHn || "—"}</span></div></td>
                    <td><div className="incoming-schedule-cell"><span title={props.order || ""}>{props.order || "—"}</span><span className="incoming-schedule-insurance" data-cash={isCash || undefined} title={`สิทธิการเบิก: ${healthInsurance || "—"}`}>{healthInsurance || "—"}</span></div></td>
                    <td><div className="incoming-schedule-cell"><span title={phone}>{phone || "—"}</span></div></td>
                    <td><div className="incoming-schedule-cell incoming-schedule-action"><button type="button" className="btn btn-outline-primary btn-sm"
                      disabled={!incomingPatient || !onEditIncoming} aria-label={`Edit Incoming: ${name}`}
                      title={incomingPatient ? "แก้ไข Incoming" : "ไม่พบรายการ Incoming ที่เชื่อมโยงอย่างชัดเจน"}
                      onClick={() => onEditIncoming(incomingPatient)}>แก้ไข</button></div></td>
                  </tr>;
                })}</tbody>
              </table>
            </div> : <p className="incoming-schedule-message">ไม่มีนัดตรวจ Sleep Test Scheduled ในวันที่เลือก</p>}
          </>}
      </div>
    </section>
  );
}
